import { atom } from "recoil";
export const availableRoles = atom({
    key: "availableRoles", // unique ID (with respect to other atoms/selectors)
    default: "", // default value (aka initial value)
});
